import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css'; // App.css provides .futuristic-header styles
import AboutPopup from './AboutPopup';

function Header() {
  const [showAboutPopup, setShowAboutPopup] = useState(false);

  return (
    <>
      <header className="futuristic-header">
        <div className="logo-area">
          <Link to="/">
            <img
              src={`${process.env.PUBLIC_URL}/Image/Logo.png`}
              alt="Logo"
              className="header-logo"
              style={{ width: '190px', height: '60px' }} // Increased logo size
            />
          </Link>
        </div>
        <nav className="navigation-area">
          <NavLink to="/" className={({ isActive }) => isActive ? "active-link" : ""} end>ច្បាប់</NavLink>
          <NavLink to="/legal-explanation" className={({ isActive }) => isActive ? "active-link" : ""}>សេចក្ដីកំណត់ ឬ ពន្យល់</NavLink>
          <NavLink to="/research/navigation" className={({ isActive }) => isActive ? "active-link" : ""}>អត្ថបទស្រាវជ្រាវ និង វិភាគ</NavLink>
          
          {/* Changed "About Us" link to a button-like element that triggers the popup */}
          <button 
            onClick={() => setShowAboutPopup(true)}
            className="about-nav-button"
            type="button"
          >
            អំពីយើង
          </button>
        </nav>
      </header>

      {showAboutPopup && (
        <AboutPopup onClose={() => setShowAboutPopup(false)} />
      )}
    </>
  );
}

export default Header;
